import React, { useEffect } from "react";
import { Form, Button, Input, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import * as zoneActions from "../../redux/actions/zone.actions";
import * as actionPage from "../../redux/actions/unRegisterRider.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
const { RangePicker } = DatePicker;

const UnRegisterFilters = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.pageFilter){
      form.setFieldsValue(props.pageFilter || null);
    }
  }, [props.pageFilter])

  const filterChange = async (value) => {
    const pageData = {
      ...props.pageFilter,
      ...value,
      page: 1,
    };
    props.actionPage.filterAction(pageData);
  }

  const filterreset = async () => {
    const pageData = {
      page: 1,
      limit: 10,
      date: [moment(), moment()],
    };
    props.actionPage.filterAction(pageData);
    form.resetFields();
  }
  
  return (
    <Form form={form} className="fliters_form" disabled={props?.pageLoader} onFinish={filterChange} layout="vertical" initialValues={{ modifier: 'public' }}>
      <Form.Item name={["keyword"]} label={(<>Full name, Phone number, CNIC</>)}>
        <Input allowClear style={{ maxWidth: 'inheri',}}/>
      </Form.Item>
      <Form.Item name={["date"]} label={'Date Range'}>
        <RangePicker
          allowClear={false}
          format="YYYY-MM-DD"
          placeholder="date"
        />
      </Form.Item>
      
      <Button htmlType="submit" loading={props?.pageLoader}>Search <SearchOutlined /></Button>
      <Button loading={props?.pageLoader} onClick={()=>filterreset()}>Reset</Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    pageLoader: state.UnRegisterRiderReducer.initialLoading,
    pageFilter: state.UnRegisterRiderReducer.initialFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UnRegisterFilters);

